import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tag-counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_GenericSubPanel = _resolveComponent("GenericSubPanel")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "traits-container",
    title: "TRAITS",
    "show-info": ['Default', 'Traits']
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.Traits), (trait) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "trait-item",
          key: trait
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["trait-name", {
          'text-tagged': _ctx.isTagged(trait),
        }])
          }, [
            _createVNode(_component_GenericButton, {
              text: _ctx.Traits[trait].name,
              variant: "text",
              class: "item-hover",
              onMouseover: ($event: any) => (_ctx.showInfo('Traits', trait)),
              onClick: ($event: any) => (_ctx.tagTrait(trait))
            }, null, 8, ["text", "onMouseover", "onClick"])
          ], 2),
          _createVNode(_component_Checkbox, {
            onClick: ($event: any) => (_ctx.showInfo('Traits', trait)),
            checked: _ctx.isTagged(trait),
            onToggle: ($event: any) => (_ctx.tagTrait(trait))
          }, null, 8, ["onClick", "checked", "onToggle"])
        ]))
      }), 128)),
      _createVNode(_component_GenericSubPanel, { class: "sub-panel" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(`TRAITS: ${_ctx.state.build.info.taggedTraits}/2`), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}